import { find, get, filter } from 'lodash';

export const getSitePages = state => state.sitePages;
export const getCurrentSitePage = state => find(getSitePages(state), page => page.isCurrent);
export const getCurrentSitePageId = state => get(getCurrentSitePage(state), 'pageId');
export const getCurrentSitePageTitle = state => get(getCurrentSitePage(state), 'title');
export const getVisibleSitePages = state => filter(getSitePages(state), page => !page.hidden);
export const getMenuButtonSitePages = state =>
  filter(getSitePages(state), page => !page.hidden || page.pageId === getCurrentSitePageId(state));
